// extracted by mini-css-extract-plugin
export var blogHighlightedText = "HighlightedText-module--blogHighlightedText--+ho+A";